import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClock,
  faPhone,
  faStethoscope,
  faBars,
} from '@fortawesome/free-solid-svg-icons';
import { Logo } from '../layout/Logo';

import { useLocation } from "react-router-dom";


export const Header = () => {

const location = useLocation();

const phoneNumber = localStorage.getItem('phoneNumber')
const key = localStorage.getItem('key')
const code = localStorage.getItem('code')

  return (
    <div className="main_header w-100 FooterHeaderBackgroundImage">
      <div className="header_container">
        <div className="menu_wrapper menu_sticky">
          <div className="mx-2 tophead d-md-block d-none py-0">
            <div className="d-flex align-items-center justify-content-between">
              <div className="h-info text-right IRANSans_Medium d-flex align-items-center">
                <Logo
                  className="img ml-4"
                  alt="a"
                  style={{ maxWidth: '15%' }}
                />
                <div className="d-flex flex-row align-items-end">
                  <h6 className="text-white mb-0" style={{ fontSize: '14px' }}>
                    <FontAwesomeIcon
                      icon={faClock}
                      className="ml-2"
                      style={{ fontSize: '10px' }}
                    />
                    ساعت کاری : همه روزه شنبه تا چهارشنبه - 14 تا 20
                  </h6>
                  <span
                    className="text-white mx-3"
                    style={{ fontSize: '14px' }}
                  >
                    <FontAwesomeIcon icon={faPhone} className="ml-2" />
                    0170000000 - 017000000
                  </span>
                </div>
              </div>
              <a
                href="./Login"
                className="quick-btn text-lg-left custom-button d-flex"
                style={{ fontSize: '15px' }}
              >
                <FontAwesomeIcon icon={faStethoscope} className="ml-2" />
                <span className={'w-auto'}>ورود به سایت</span>
              </a>
            </div>
          </div>

          <div
            id="navigation"
            className="of-drop-down of-main-menu"
            role="navigation"
          ></div>

          <div className="is-show mobile-nav-button">
            <img src="Img/Logo.png" alt="" />
            <a id="of-trigger" className="icon-wrap pr-3" href="#">
              <FontAwesomeIcon icon={faBars} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
